import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = ["onSubmit"]

import { Ref, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TodoInputComponent',
  emits: ["handleSubmit"],
  setup(__props, { emit: emits }) {



const todoInputItem: Ref<string> = ref('');

function handleFormSubmit() {
  emits('handleSubmit', todoInputItem.value);
  todoInputItem.value = '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
    }, [
      _withDirectives(_createElementVNode("input", {
        class: "w-[400px] bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 outline-none",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((todoInputItem).value = $event))
      }, null, 512), [
        [_vModelText, todoInputItem.value]
      ])
    ], 40, _hoisted_2)
  ]))
}
}

})